import { getFormatDate } from '@/helper/utily'

export const getPeriodReport = {
  methods: {
    getReportPeriod(semdFrom, semdTo) {
      let from = getFormatDate(semdFrom, 'Do MMMM', 'DD/MM/YYYY hh:mm:ss')
      let to = getFormatDate(semdTo, 'Do MMMM YYYY', 'DD/MM/YYYY hh:mm:ss')

      if (!semdFrom || !semdTo) {
        return '-'
      }
      return from + ' to ' + to
    },
  },
}
